<template>
  <main class="content">
    <!-- content -->
    <section class="how-work">
      <div class='container'>
        <div class="how-work__wrapper">
          <div class="how-work__info">
            <h2 class="how-work__title">Как это работает?</h2>
            <ul class="how-work__list">
              <li class="how-work__li"><span>А</span><p>Вы сами подготовите документы <br>Документы – это конструктор, который Вы «соберете» индивидуально под свою ситуацию и стоит это 299 рублей. Все ситуации типичны, а особенности Вашего дела мы тоже учли!</p></li>
              <li class="how-work__li"><span>Б</span><p>Юристы потратили сотни часов чтобы Вы могли все сделать сами. Вам останется лишь направить подготовленные жалобы, заявления, ходатайства и другие документы в зависимости от ситуации в суд или иную инстанцию.</p></li>
              <li class="how-work__li"><span>В</span><p>В инструкции четко прописана вся последовательность действий и все возможные шаги – разберется даже ребенок! Вы просто выигрываете свое дело на раз-два-три!</p></li>
            </ul>
          </div>
          <div class="how-work__down">
            <div class="how-work__video">
              <iframe class="how-work__link" src="https://www.youtube.com/embed/oPNO94w-86Q"></iframe>
            </div>
            <div class="how-work__text text-work">
              <h3 class="text-work__title">Больше не нужны Автоюристы</h3>
              <p class="text-work__text">
                Не верьте неграмотным юристам, которые умеют хорошо продавать и не умеют также хорошо решать проблемы своих клиентов.
                <br>
                Вас могут пугать судом, рассказывать небылицы, уговаривать ни за что не ходить в суд самому, а обязательно отправить туда юриста. Об этом мы писали много раз.
                <br>
                На самом деле, в суде не важно ничего кроме юридически выверенных доказательств. Документы, которые Вы подаете в суд это и есть доказательства и работают они ровно так как они были подготовлены.
                <br>
                Нажимайте кнопку «Получить  документы» и не откладывая решите любой спор в свою пользу.
</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
  export default {
      name: 'how'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/how.vue